import { ADD_FERTILIZER, EDIT_FERTILIZER, SELECT_FERTILIZER_TO_EDIT, DELETE_FERTILIZER,
  PREPARE_DATA, SET_FERTILIZER_FORM, FETCH_FERTILIZER_APPLICATIONS,
  SELECT_FERTILIZER_APPLICATION, DELETE_FERTILIZER_APPLICATION, SELECT_FERT_APP_TO_EDIT
 } from './types';
import { ROOT_URL } from '../../constants';
import { fillForm, findEmployeeByName, resetForm, generateID, acresPerHour, tonsPerAcre,
  tonsPerHour, acresBalance, checkApplicationForm, uniqueElementsByRight } from '../cult_utils';
import { fetchFields } from './utils_actions';
import { error, success } from './chem_actions';
import axios from 'axios';
const $ = window.$;
/**
* fetchFertilizerApplications(): Fetches all recent fertilizer applications
* @returns {Array} fertilizerApps
* @called-in: ['/components/chemical/fertilizer_app_view.js']
**/
export function fetchFertilizerApplications() {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchFertilizerApplications`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        $('#preloader').css('display','none');
        dispatch({ type: FETCH_FERTILIZER_APPLICATIONS, payload: res.data.fertApps });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch(error(`There was an error fetching fertilizer applications.`));
      });
  }
}
/**
* createOrEditFertilizerApplication(): Creates a fertilzier record
* @param {Object} data: fert application
* @param {String} type: Create or edit. Redux type
* @param {String} path: Routing path to server
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js->fertilizer_form.js']
**/
export function createOrEditFertilizerApplication({ data, type, path }) {
  if (checkApplicationForm(data)) return error('Entire form must be filled.');
  if (data.fertilizerApplied.length === 0) return error('At least one fertilizer is required.');
  for (let f of data.fertilizerApplied) if (Number(f.acresBalance) < -5.0) return error(`Cannot exceed total acres in a field. Re-enter Acres Completed.`);
  for (let f of data.fertilizerApplied) if (f.appType === 'L' && Number(data.measurement) === 0) return error(`Total Gallons must be greater than 0 for foliar applications.`);
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.post(`${ROOT_URL}/${path}`, { data })
      .then((res) => {
        $('#preloader').css('display','none');
        resetForm('fertilizer-application-form');
        let { msg, record } = res.data;
        success(msg);
        dispatch({ type, payload: record });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch({type: 'ERROR', payload: err});
      });
  }
}
/**
* deleteFertilizerApplication(): Deletes a fertilzier record
* @param {String} fertAppId: id of fertilizer application
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_view.js->fab_modal_v2.js']
**/
export function deleteFertilizerApplication({ fertAppId }) {
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.post(`${ROOT_URL}/deleteFertilizerApplication`, { fertAppId })
      .then((res) => {
        $('#preloader').css('display','none');
        success(res.data.msg);
        dispatch({ type: DELETE_FERTILIZER_APPLICATION, payload: res.data.fertAppId });
      }).catch((err) => {
        $('#preloader').css('display','none');
        dispatch({type: 'ERROR', payload: err});
      });
  }
}

/**
* prepareData(): Prepares a fert application for submission
* @param {Object} fertilizer: fertUsed
* @param {String} formId: id of form
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js']
**/
export function prepareData({ user, form, fields, employees, fertilizerApplied, fertAppId, editingApplication }) {
  let e = findEmployeeByName(form.employee, employees);
  let isComplete = form.isComplete === 'Incomplete' ? 0 : 1;
  // If EID is filled in form
  if (!e && form.employee !== '') e = employees.find((emp) => emp.eid === form.employee);
  for (let fert of fertilizerApplied) {
    let field = fields.find((f) => f.field === fert.field);
    fert.acresBalance = acresBalance(fert.acresCompleted, field.totalAcre);
  }
  delete form.solidOrLiquid;
  $('#preloader').css('display','block');
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchPreviousFertApplications`, {
      params: { date: form.date, fertilizerApplied: JSON.stringify(fertilizerApplied), round: form.round, isComplete },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
      $('#preloader').css('display','none');
      let { prevApps } = res.data;
      // If editing application, do not fetch any of the records that are potentially being edited
      if (editingApplication) {
        prevApps = prevApps.map((p) => {
          // eslint-disable-next-line
          if (fertilizerApplied.find((f) => f.id === p.id)) return;
          return p;
        }).filter((p) => p !== undefined)
      }
      // Update the balance if previous submissions exist for round, field, year
      for (let f of fertilizerApplied) {
        let selectedField = fields.find((_f) => _f.field === f.field);
        let previousAcresWorked = prevApps.filter((p) => p.field === f.field && p.id !== f.id)
                                                   .reduce((acc, cur) => { return acc + Number(cur.acresCompleted) },0);
        if (editingApplication) previousAcresWorked = 0;
        let totalAcresWorked = Number(f.acresCompleted);
        if (f.appType === 'S') totalAcresWorked += previousAcresWorked
        if (f.appType === 'L') {
          let uniqueAcres = uniqueElementsByRight(prevApps, (a,b) => a.fertAppId === b.fertAppId);
          totalAcresWorked += uniqueAcres.reduce((acc, cur) => { return acc + Number(cur.acresCompleted) }, 0);//Math.max(...prevApps.map((_f) => _f.acresCompleted));
        }
        let balance = acresBalance(totalAcresWorked, selectedField.totalAcre);
        f.acresBalance = balance;
      }
      dispatch({
        type: PREPARE_DATA,
        payload: {
          ...form,
          fertAppId: fertAppId ? fertAppId : generateID(),
          employee: e.eid,
          isComplete,
          canEdit: 1,
          submitter: user.eid,
          fertilizerApplied: fertilizerApplied,
          editedBy: editingApplication ? user.eid : null
        },
        previousApplications: prevApps
      });
    }).catch((err) => {
      $('#preloader').css('display','none');
      dispatch({type: 'ERROR', payload: err});
    });
  }
}
/**
* selectFertAppToEdit(): Sets the application to edit
* @param {Object} app: app to edit
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js']
**/
export function selectFertAppToEdit({ formId, app, employees }) {
  let employee = employees.find((e) => e.eid === app.employee);
  if (employee) app.employee = `${employee.firstName} ${employee.lastName}`;
  // Fill form
  fillForm(formId, app);
  // After form is filled, set employee back to eid
  app.employee = employee.eid;
  return (dispatch) => {
    dispatch(fetchFields(app.location));
    dispatch({
      type: SELECT_FERT_APP_TO_EDIT,
      payload: app
    });
  }
}
/**
* addFertilizer(): Adds a fertilzier record in the create application form
* @param {Object} fertilizer: fertUsed
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js->fertilizer_form.js']
**/
export function addFertilizer({ fertilizer, formId, chemicals }) {
  let { chemId } = fertilizer;
  for (let key in fertilizer) {
    if (fertilizer[key] === '') return error('All fields must be filled.');
    if (!isNaN(fertilizer[key]) && Number(fertilizer[key]) <= 0) return error('Value must be greater than 0.');
  }
  let chem = chemicals.find((c) => c.id === Number(chemId));
  resetForm(formId);
  return {
    type: ADD_FERTILIZER,
    payload: {
      id: generateID(),
      chemId: chem.id,
      acresPerHour: acresPerHour(fertilizer.hours, fertilizer.acresCompleted),
      quantityPerAcre: tonsPerAcre(fertilizer.quantityApplied, fertilizer.acresCompleted),
      quantityPerHour: tonsPerHour(fertilizer.quantityApplied, fertilizer.hours),
      ...fertilizer,
      formId
    }
  }
}
/**
* editFertilizer(): Edits a fertilzier record in the create application form
* @param {Object} fertilizer: fertUsed
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js->fertilizer_form.js']
**/
export function editFertilizer({ fertilizer, fertAppId, editFertilizerApplied, formId, chemicals }) {
  let { chemId } = fertilizer;
  for (let key in fertilizer) {
    if (fertilizer[key] === '') return error('All fields must be filled.');
    if (!isNaN(fertilizer[key]) && Number(fertilizer[key]) <= 0) return error('Value must be greater than 0.');
  }
  let chem = chemicals.find((c) => c.id === Number(chemId));
  resetForm(formId);
  // ON EDIT APPLICATION ONLY: Check if a fertAppId exists, if so, add it to object
  if (Object.keys(editFertilizerApplied).length > 0) {
    fertilizer.fertAppId = editFertilizerApplied.fertAppId;
    fertilizer.id = editFertilizerApplied.id;
  }
  return {
    type: EDIT_FERTILIZER,
    payload: {
      chemId: chem.id,
      acresPerHour: acresPerHour(fertilizer.hours, fertilizer.acresCompleted),
      quantityPerAcre: tonsPerAcre(fertilizer.quantityApplied, fertilizer.acresCompleted),
      quantityPerHour: tonsPerHour(fertilizer.quantityApplied, fertilizer.hours),
      ...fertilizer,
      formId
    }
  }
}
/**
* deleteFertilizer(): Deletes a fertilzier record in the create application form
* @param {Object} fertilizer: fertUsed
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js->fertilizer_form.js']
**/
export function deleteFertilizer({ fertilizer }) {
  return {
    type: DELETE_FERTILIZER,
    payload: fertilizer
  }
}
/**
* selectFertilizerToEdit(): Selects a fertilzier record to edit
* @param {Object} fertilizer: fertUsed
* @param {String} formId: id of form
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js']
**/
export function selectFertilizerToEdit({ fertilizer, formId }) {
  let solOrLiq = 'S';
  if (fertilizer.unitOfMeasure === 'tons') {
    document.getElementById('fert-solid').checked = true;
    setTimeout(() => {
      fillForm(formId, fertilizer);
    }, 500)
  } else {
    document.getElementById('fert-liquid').checked = true;
    solOrLiq = 'L';
    setTimeout(() => {
      fillForm(formId, fertilizer);
    }, 500)
  }
  return {
    type: SELECT_FERTILIZER_TO_EDIT,
    payload: fertilizer,
    solOrLiq
  }
}
/**
* setFertilizerForm(): Sets the type of form used for fertilizer submissions(Ganular or foliar app)
* @param {Object} fertilizer: fertUsed
* @param {String} formId: id of form
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_create.js']
**/
export function setFertilizerForm({ val }) {
  return {
    type: SET_FERTILIZER_FORM,
    payload: val
  }
}
/**
* selectFertilizerApplication(): Sets the application to view or delete
* @param {Object} app: app to view/delete
* @returns {Array} type, payload
* @called-in: ['/components/fertilizer/fertilizer_view.js']
**/
export function selectFertilizerApplication(app) {
  return {
    type: SELECT_FERTILIZER_APPLICATION,
    payload: app
  }
}












































/* END */



// WEBPACK FOOTER //
// ./src/cultivation/actions/fertilizer_actions.js